<template>
  <div id="app">
    <div id="home1" class="container-fluid standard-bg">
      <!-- HEADER -->
      <div class="row header-top">
        <div class="col-lg-3 col-md-6 col-sm-5 col-xs-8">
          <router-link :to="{ name: 'Home' }" class="main-logo">
            <img src="/static/img/itrtv-logo.jpg" class="main-logo img-responsive" alt="ITRTV" title="ITRTV - La télé du numérique">
          </router-link>
        </div>
        <div class="col-lg-9 hidden-md text-right hidden-sm hidden-xs">
          <br>
          <ad format="header"></ad>
        </div>
      </div>
      <!-- MENU -->
      <div class="row home-mega-menu ">
        <div class="col-md-12">
          <nav class="navbar navbar-default">
            <div class="navbar-header">
              <button class="navbar-toggle" type="button" data-toggle="collapse" data-target=".js-navbar-collapse">
                <span class="sr-only">Activer/Désactiver navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="collapse navbar-collapse js-navbar-collapse megabg dropshd ">
              <ul class="nav navbar-nav">
                <li>
                  <router-link :to="{ name: 'Home' }">Accueil</router-link>
                </li>
              </ul>
              <social></social>
              <div class="search-block">
                <form @submit.prevent="searchVideos">
                  <input type="search" placeholder="Rechercher" v-model="query">
                </form>
              </div>
            </div>
            <!-- /.nav-collapse -->
          </nav>
        </div>
      </div>
      <!-- CORE -->
      <div class="row">
        <!-- SIDEBAR -->
        <div class="col-md-2 hidden-sm hidden-xs">
          <aside class="dark-bg">
            <article>
              <h2 class="icon"><i class="fa fa-flash" aria-hidden="true"></i>Actualités</h2>
              <vimeo-channels scope="portfolios">
                <template slot-scope="props">
                  <ul class="sidebar-links">
                    <li class="fa fa-chevron-right" v-for="portfolio in props.data">
                      <router-link :to="{ name: 'AllVideos', params: { type: 'portfolios', id: portfolio.id, page: 1, title: getCategoryTitle(portfolio.name) } }">{{ portfolio.name }}</router-link>
                    </li>
                  </ul>
                </template>
              </vimeo-channels>
            </article>
            <div class="clearfix spacer"></div>
            <article>
              <h2 class="icon"><i class="fa fa-gears" aria-hidden="true"></i>Tendances</h2>
              <vimeo-channels scope="albums">
                <template slot-scope="props">
                  <ul class="sidebar-links">
                    <li class="fa fa-chevron-right" v-for="album in props.data">
                      <router-link :to="{ name: 'AllVideos', params: { type: 'albums', id: album.id, page: 1, title: getCategoryTitle(album.name) } }">{{ album.name }}</router-link>
                    </li>
                  </ul>
                </template>
              </vimeo-channels>
            </article>
            <div class="clearfix spacer"></div>
          </aside>
        </div>
        <!-- HOME MAIN POSTS -->
        <div class="col-md-10">
          <section id="home-main">
            <div class="row">
              <div class="col-lg-9 col-md-12 col-sm-12">
                  <router-view></router-view>
              </div>
              <!-- RIGHT ASIDE -->
              <div class="col-lg-3 hidden-md col-sm-12 text-center top-sidebar">
                <!-- SUBSCRIBE BOX -->
                <div class="subscribe-box">
                  <h2 class="icon"><i class="fa fa-plug" aria-hidden="true"></i>S'abonner</h2>
                  <!-- SUBSCRIBE FIELD -->
                  <add-subscriber ref="addSubscriber" broadcastChannel="ITRTV"></add-subscriber>
                  <form name="search-submit" id="subscribe-submit" @submit.prevent="subscribe">
                    <fieldset class="search-fieldset">
                      <input id="subscribe" type="text" name="search" size="12" class="search-field" placeholder="Votre adresse email" v-model="subscriberEmail">
                      <button class="subscribe-btn" type="submit" title="Newsletter">S'abonner</button>
                    </fieldset>
                  </form>
                  <p class="text-center">
                    <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
                  </p>
                </div>
                <!-- SIDEBAR ADVERTISE BOX -->
                <a class="banner-l hidden-sm hidden-xs">
                  <ad format="sidebar"></ad>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- BOTTOM BANNER -->
    <div id="bottom-banner" class="container text-center">
      <!-- BOTTOM ADVERTISE BOX -->
      <a class="banner-xl">
        <ad format="header"></ad>
      </a>
    </div>
    <!-- FOOTER -->
    <div id="footer" class="container-fluid footer-background">
      <div class="container">
        <footer>
          <!-- SECTION FOOTER -->
          <div class="row">
            <!-- SOCIAL -->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div class="row auto-clear">
                <div class="col-md-12">
                </div>
                <div class="col-md-12">
                  <social></social>
                </div>
                <div class="col-md-12">
                  <p>
                    <b>Groupe ITRnews</b><br>
                    Carré des Archives<br>
                    75 rue des Archives<br>
                    75003 Paris
                    <br><br>

                    <b>Pour nous contacter :</b><br>
                    Tél : 01 40 16 10 77
                    <br><br>

                    <b>Publicité</b><br>
                    Tél : 01 40 16 18 48<br>
                    Fax : 01 49 95 00 23<br>
                    <a href="mailto:publicite@itrtv.com" target="_blank">Contactez nous par mail</a>
                    <br><br>

                    <b>Rédaction</b><br>
                    Tél : 01 40 16 18 55<br>
                    <a href="mailto:redaction@itrtv.com" target="_blank">Contactez nous par mail</a>
                  </p>
                </div>
              </div>
            </div>
            <!-- TAGS -->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <h2 class="title">Les plus partagées</h2>
              <vimeo-videos
                :per_page="4"
                sort="likes"
                :page="1"
              >
                <template slot-scope="props">
                  <ul class="footer-menu-links">
                    <li v-for="video in props.videos">
                      <router-link :to="{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }"> {{ video.name }}</router-link>
                    </li>
                  </ul>
                </template>
              </vimeo-videos>
            </div>
            <!-- POST -->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <h2 class="title">Interviews</h2>
              <div class="row auto-clear">
                <vimeo-videos
                  :per_page="6"
                  query="interview"
                  :page="1"
                >
                  <template slot-scope="props">
                    <div class="col-lg-6 col-md-6 col-sm-6 post post-medium" v-for="video in props.videos">
                      <div class="thumbr">
                        <router-link :to="{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }" class="post-thumb">
                          <span class="play-btn-border" title="play"><i class="fa fa-play-circle headline-round" aria-hidden="true"></i></span>
                          <div class="cactus-note ct-time font-size-1"><span>{{ video.durationstring }}</span></div>
                          <img class="img-responsive" :src="video.pictures.sizes[2].link" alt="#">
                        </router-link>
                      </div>
                    </div>
                  </template>
                </vimeo-videos>
              </div>
            </div>
            <!-- LINKS -->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <h2 class="title">Les plus vues</h2>
              <vimeo-videos
                :per_page="4"
                sort="plays"
                :page="1"
              >
                <template slot-scope="props">
                  <ul class="footer-menu-links">
                    <li v-for="video in props.videos">
                      <router-link :to="{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }"> {{ video.name }}</router-link>
                    </li>
                  </ul>
                </template>
              </vimeo-videos>
            </div>
          </div>
          <br>
          <div class="row copyright-bottom text-center">
            <site-footer class="inline"></site-footer>
            <br><br>
            <p class="text-center">
              <router-link :to="{ name: 'RGPD' }">Voir la politique de confidentialité</router-link>
            </p>
            <br/>
            <div class="col-md-12 text-center">
              <div class="footer-logo" title="ITRTV">
                <img src="/static/img/itrtv-logo.jpg" class="img-responsive text-center" alt="ITRTV">
              </div>
              <p>&copy; Copyright 2017. Tous droits réservés. ITRTV</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  import { kebabCase } from 'lodash';
  import { Ad, SiteFooter, AddSubscriber, VimeoVideos, VimeoChannels } from 'itrnews-vuejs-api';
  import Social from './components/elements/Social';

  export default {
    name: 'app',
    components: {
      VimeoVideos,
      VimeoChannels,
      Ad,
      SiteFooter,
      AddSubscriber,
      Social,
    },
    methods: {
      subscribe(event) {
        event.preventDefault();
        this.$refs.addSubscriber.sendRequest(this.subscriberEmail);
      },
      searchVideos(event) {
        event.preventDefault();
        this.$router.push({ name: 'Search', params: { query: this.query } });
      },
      getCategoryTitle(title) {
        return kebabCase(title);
      },
    },
    data() {
      return {
        subscriberEmail: '',
        query: '',
      };
    },
  };
</script>

<style scoped>
  .inline {
    display: inline;
  }
  h2 {
    font-size: 20px !important;
  }
</style>
<style>
  .post.post-medium {
    min-height: 250px;
  }

  @media only screen and (max-width: 1180px) {
    .post.post-medium {
      min-height: 380px !important;
    }
  }
  .post .ratings {
    position: absolute;
    bottom: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue